import React, { Component, Fragment } from "react";
import {
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  Alert
} from "reactstrap";
import classnames from "classnames";

import AppNavbar from "../AppNavbar";
import Devices from "../Devices";
import AdminTabs from "../AdminTabs";
import AddDeviceModal from "../AddDeviceModal";

import { Container } from "reactstrap";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { login } from "../../actions/authActions";

import { clearErrors } from "../../actions/errorActions";

class Login extends Component {
  state = {
    activeTab: "1",
    modal: false,
    username: "",
    password: "",
    msg: null
  };

  static propTypes = {
    isAuthenticated: PropTypes.bool,
    error: PropTypes.object.isRequired,
    clearErrors: PropTypes.func.isRequired,
    login: PropTypes.func.isRequired
  };

  componentDidUpdate(prevProps) {
    const { error } = this.props;

    if (error !== prevProps.error) {
      //Check for login error
      if (error.id === "LOGIN_FAIL") {
        this.setState({ msg: error.msg.msg });
      } else {
        this.setState({ msg: null });
      }
    }
  }

  onChange = e => {
    this.setState({ [e.target.name]: e.target.value });
    this.props.clearErrors();
  };

  onSubmitLogin = e => {
    e.preventDefault();

    const { username, password } = this.state;

    const user = {
      username,
      password
    };

    //Attempt to login
    this.props.login(user);
  };

  render() {
    return (
      <div>
        {this.props.isAuthenticated ? (
          this.props.user &&
          this.props.user[0] &&
          this.props.user[0].userType === "staff" &&
          this.props.user[0].isAdmin === "Yes" ? (
            <Fragment>
              <AppNavbar />
              <AdminTabs />
            </Fragment>
          ) : (
            <Fragment>
              <AppNavbar />
              <Container>
                <AddDeviceModal />
                <Devices />
              </Container>
            </Fragment>
          )
        ) : (
          <Fragment>
            <AppNavbar />
            <div className="d-flex justify-content-center Login">
              <div className="image" />
              <div className="form">
                <Nav tabs>
                  <NavItem>
                    <NavLink
                      className={classnames({
                        active: this.state.activeTab === "1"
                      })}
                      onClick={() => {
                        this.toggle("1");
                      }}>
                      Log In
                    </NavLink>
                  </NavItem>
                </Nav>
                <TabContent activeTab={this.state.activeTab}>
                  <TabPane tabId="1">
                    <Form onSubmit={this.onSubmitLogin}>
                      <FormGroup>
                        {this.state.msg ? (
                          <Alert color="danger"> {this.state.msg}</Alert>
                        ) : null}
                        <Label for="un" className="mt-2">
                          Username:
                        </Label>
                        <Input
                          type="text"
                          name="username"
                          id="username"
                          placeholder="Username"
                          onChange={this.onChange}
                        />
                        <br />

                        <Label for="pw">Password:</Label>
                        <Input
                          type="password"
                          name="password"
                          id="password"
                          placeholder="Password"
                          onChange={this.onChange}
                        />
                        <p>
                          <a href="https://secure.truman.edu/password/">
                            {" "}
                            Forgot your password?
                          </a>
                        </p>
                        <Button
                          color="primary"
                          style={{ marginTop: "2rem" }}
                          block>
                          Login
                        </Button>
                      </FormGroup>
                    </Form>
                  </TabPane>
                </TabContent>
              </div>
            </div>
          </Fragment>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  isAuthenticated: state.auth.isAuthenticated,
  user: state.auth.user,
  error: state.error
});

export default connect(mapStateToProps, { login, clearErrors })(Login);
